import React from 'react';

import { LottoCombinations } from 'src/interfaces/LottoState';
import BetslipState, { Bet } from '../../../../interfaces/BetslipState';

export interface NumberBetContextProps {
    index?: number,
    singleBet: Bet,
    amount: string,
    banker: boolean,
    setBanker: Function,
    date: Date,
    validMessage: string,
    checkCombinable?: boolean,
    stake?: {
      stake?: number,
      maximumProfit?: number,
      profit: number,
      singleStake: number,
    },
    selectedSlip: number,
    combinations: LottoCombinations,
    singleSlip: BetslipState['singleSlip']
    selectedOddsType: string
    allowStakes?: boolean,
    isPortrait: boolean,
    showCombinableWarning: boolean,
    setAllowStakes: Function,
    showCombinations: boolean,
    setShowCombinations: Function,
    setAmount: Function,
    handleUpdate: () => void,
    // eslint-disable-next-line no-unused-vars
    changePermutations: (event : any) => Promise<void>,
    onAmountChange: Function
}

const NumberBetContext = React.createContext<Partial<NumberBetContextProps>>({
  index: 0,
  amount: '',
  banker: false,
  setBanker: () => {},
  singleBet: {},
  checkCombinable: false,
  stake: {
    stake: 0,
    maximumProfit: 0,
    profit: 0,
    singleStake: 0
  },
  combinations: {
    odds: 0,
    rankedNumbers: [],
    repetitionsCount: 0,
    anyNumbers: [],
    permutationsCount: 0,
    permutations: [],
    maximumProfit: 0,
    numbersToPredictCount: 0
  },
  showCombinations: false,
  setShowCombinations: () => {},
  allowStakes: true,
  isPortrait: false,
  date: new Date(),
  validMessage: '',
  showCombinableWarning: false,
  selectedOddsType: '',
  setAllowStakes: () => {},
  setAmount: () => {},
  handleUpdate: () => {},
  changePermutations: () => Promise.resolve(),
  onAmountChange: () => {},
  selectedSlip:0,
  singleSlip: null
});

export default NumberBetContext;
